import { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import { connect, useDispatch } from "react-redux";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Typography, Divider, MenuItem, Chip, Box } from "@mui/material";
import Papa from "papaparse";
import "./UserTerminals.css";
import _ from "lodash";
import authReducer from "../../../reducers/authReducer";
import { ACTION_TYPES, addKitToWarehouseAPI } from "../slice";
import { toast } from "react-toastify";
import { IconButton } from "@mui/material";
import { GetApp as GetAppIcon, Close as CloseIcon } from "@mui/icons-material";
import { patterns } from "../../../utils/util";
import AddEditInterfaceModal from "../../../UserScreen/InventoryPage/InventorySettings/components/Modals/AddEditInterfaceModal";


function AddStarlink(props) {
  const { open, onClose, newSummaryServiceAccount, authReducer, addKitToWarehouseAPI, addKitToWareHouseRes } = props;
  const dispatch = useDispatch();
  const [parsedIds, setParsedIds] = useState([]);
  const [starlinkIds, setStarlinkIds] = useState("");
  const [validationResults, setValidationResults] = useState<any[]>([]);
  const filteredAccounts = newSummaryServiceAccount?.filter( (acc) => acc.accountNumber !== "All");
  const [selectedAccount, setSelectedAccount] = useState<any>(null);


  const formatStarlinkId = (input: string) => {
    const cleaned = input.replace(/[^0-9a-f]/gi, "");
    let parts: any = [];
    if (cleaned.length > 8) parts.push(cleaned.substring(8, 16));
    if (cleaned.length > 16) parts.push(cleaned.substring(8, 16));
    if (cleaned.length > 24) parts.push(cleaned.substring(16, 24));
    if (parts.length < 3) parts.push(cleaned.substring(parts.join("").length));
    return parts.filter(Boolean).join("-");
  }

  const validateInputs =(ids: string[]) => {
    const seen = new Set<string>();

    return ids.map((rawId) => {
      const id = rawId.trim();

      if (!/^[A-Z0-9-]+$/i.test(id)) {
        return { id, type: "INVALID_CHAR", valid: false };
      }

      if (seen.has(id.toUpperCase())) {
        return { id, type: "DUPLICATE", valid: false };
      }
      seen.add(id.toUpperCase());

      if (patterns.kit.test(id) && id.length > 8) {
        return { id, type: "KIT", valid: true };
      }
      if (patterns.starlinkId.test(id)) {
        return { id, type: "STARLINK_ID", valid: true };
      }
      if (patterns.dish.test(id)) {
        return { id, type: "DISH", valid: true };
      }

      return { id, type: "UNKNOWN", valid: false };
    });
  }


  const handleInputChange = (value) => {
    setStarlinkIds(value);

    let items = value.split(",").map(s => s.trim()).filter(Boolean);

   items = items.map((item) => {
  if (item.toUpperCase().startsWith("KIT")) {
    return item;
  } else if (/^[0-9a-f]{24,32}$/i.test(item)) {
    return formatStarlinkId(item);
  } else {
    return item;
  }
});

    const results = validateInputs(items);
    setValidationResults(results);
  };

const handleCsvUpload = (e) => {
  setStarlinkIds("");
    setParsedIds([]);
    setValidationResults([])
    
  const file = e.target.files[0];
  if (!file) return;

  Papa.parse(file, {
    header: false,
    complete: (result) => {
      const rows = result.data;

      for (let i = 1; i < rows.length; i++) { 
        const row = rows[i];
        if (row.slice(1).some((col) => col && col.trim() !== "")) {
          toast.error(`Invalid CSV: Only the first column is allowed (error at row ${i + 1}). Please refer to the template.`, {
        position: toast.POSITION.BOTTOM_LEFT,
      })
      
          return; 
        }
      }

      let ids = rows.map((row) => row[0]?.trim()).filter(Boolean);
      ids = ids.slice(1);

      setParsedIds(ids);
      setStarlinkIds(ids.join(", "));
      const results = validateInputs(ids);
      setValidationResults(results);
    },
    error: (error) => {
      toast.error("Failed to parse CSV");
      console.error(error);
    },
  });
   e.target.value = "";
};

  const handleAddStarlinks = () => {
    const ids = starlinkIds
      .split(",")
      .map((id) => id.trim())
      .filter((id) => id.length > 0);

    if (_.isEmpty(ids)) {
      alert("Please enter Starlink IDs.");
      return;
    }

    try {
      let params = {
        accountNumber: selectedAccount?.accountNumber,
        organizationId: authReducer?.selectedOu?.id,
        userTerminalIds: starlinkIds?.split(",")?.map(id => id.trim())
      }

      addKitToWarehouseAPI(params)
      closePopup()

    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (!_.isEmpty(addKitToWareHouseRes)) {
      toast.success(` ${addKitToWareHouseRes?.message}`, {
        position: toast.POSITION.BOTTOM_LEFT,
      })
      dispatch({ type: ACTION_TYPES?.ADD_KIT_TO_WAREHOUSE, payload: {} })
    }

  }, [addKitToWareHouseRes])

  const closePopup = () => {
    setStarlinkIds("");
    setParsedIds([]);
    setSelectedAccount(null);
    setValidationResults([])
    onClose();
  }

  const handleAccountChange = (serviceAccount) => {
    const account = filteredAccounts.find(   (acc) => acc.accountNumber === serviceAccount );
     setStarlinkIds("");
    setParsedIds([]);
    setSelectedAccount(null);
    setValidationResults([])

    setSelectedAccount(account);
  };

  const handleRemoveChip = (idToRemove: string) => {
    const updated = validationResults.filter(r => r.id !== idToRemove);
    setValidationResults(updated);
    setStarlinkIds(updated.map(r => r.id).join(", "));
  };

  const handleDownloadTemplate = () => {
    const csvContent = "KIT/Starlink ID\nKIT12345678\nKIT98765432\nKIT0011223344";
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.setAttribute("download", "starlink_template.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const layout =  [
      {
        columns: [
          {
            component: (
              <Typography variant="body2" className="starlink-terminal-add-text">
                Add new Starlinks to your account. These starlinks must be unlocked
                by the owner and will not be activated until you add them to a
                service line.
              </Typography>
            ),
          },
        ],
      },
      {
        columns: [
          {
            component: (
              <TextField
                select
                label="Select Account"
                value={selectedAccount?.accountNumber || ""}
                onChange={(e) => handleAccountChange(e.target.value)}
                fullWidth
                margin="normal"
                className="starlink-terminal-add-dropdown"
              >
                {filteredAccounts.map((acc) => (
                  <MenuItem key={acc.accountNumber} value={acc.accountNumber}>
                    {acc.accountName} ({acc.accountNumber})
                  </MenuItem>
                ))}
              </TextField>
            ),
          },
        ],
      },
      {
        columns: [
          {
            component: (
              <TextField
                fullWidth
                variant="outlined"
                placeholder="KIT SERIAL NUMBER, STARLINK ID, OR DISH SERIAL NUMBER"
                value={starlinkIds}
                onChange={(e) => handleInputChange(e.target.value)}
                error={validationResults.some((r) => !r.valid)}
                helperText={
                  validationResults.some((r) => !r.valid)
                    ? "One or more entries are invalid"
                    : "You can input a single ID or a comma separated list of KIT, Starlink ID, or Dish Serial"
                }
              />
            ),
          },
        ],
      },
      {
        columns: [
          {
            component: (
              <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
                {validationResults?.map((res, i) => (
                  <Chip
                    key={i}
                    label={`${res.id} (${res.type})`}
                    color={res.valid ? "success" : "error"}
                    variant="outlined"
                    onDelete={() => handleRemoveChip(res.id)}
                  />
                ))}
              </Box>
            ),
          },
        ],
      },
      {
        columns: [
          {
            component: (
              <div className="starlink-terminal-add-upload-wrapper">
                <Button
                  variant="contained"
                  component="label"
                  className="starlink-terminal-add-upload-btn"
                >
                  Upload CSV
                  <input type="file" accept=".csv" hidden onChange={handleCsvUpload} />
                </Button>

                <Button
                  variant="text"
                  startIcon={<GetAppIcon />}
                  onClick={handleDownloadTemplate}
                  sx={{ ml: 1, color: "#1976d2" }}
                >
                  Download Template
                </Button>
              </div>
            ),
          },
        ],
      },
    ]

  return (
  <AddEditInterfaceModal
    open={open}
    onClose={closePopup}
    onSave={handleAddStarlinks}
    title="ADD STARLINK(S) TO WAREHOUSE. (BETA)"
    saveText="Add Starlinks"
    disableSave={starlinkIds === "" || !selectedAccount}
    layout={layout}
    maxWidth="740px"
  />
);

}

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
  errorReducer: state.errorReducer,
  newSummaryServiceAccount: state?.authReducer?.newSummaryServiceAccount,
  addKitToWareHouseRes: state?.starlinkAdmin?.addKitToWareHouseRes
});

export default withRouter(connect(mapStateToProps, { addKitToWarehouseAPI })(AddStarlink));
